(function () {
  var bar = document.querySelector('[data-mro-buy-bar]');
  if (!bar) return;

  var productId = bar.getAttribute('data-product-id');
  var idInput = bar.querySelector('[data-mro-buy-bar-variant-id]');
  var btn = bar.querySelector('[data-mro-buy-bar-btn]');
  var btnText = bar.querySelector('[data-mro-buy-bar-btn-text]');

  document.addEventListener('variant:update', function (event) {
    var detail = event.detail;
    if (!detail || !detail.data || String(detail.data.productId) !== String(productId)) return;

    var variant = detail.resource;

    if (!variant) {
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = 'No disponible';
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (btn) btn.disabled = !variant.available;
    if (btnText) btnText.textContent = variant.available ? 'Comprar ahora' : 'Agotado';
  });
})();
